<ion-grid>
  <ion-row class="sis-title" [ngStyle]="{ 'background-color': itemColor }" data-test="sis-operating-info-item-title">
    <ion-col>
      {{ operatingInfoTitle }}
    </ion-col>
  </ion-row>

  <ion-row
    class="sis-text"
    [ngStyle]="{ 'background-color': itemColor + '66' }"
    data-test="sis-operating-info-item-text"
  >
    <ion-col>
      <div [innerHTML]="operatingInfoText"></div>
      <div class="sis-timestamp">{{ operatingInfoTimestamp | date: 'dd.MM.yyyy HH:mm' }}</div>
    </ion-col>
  </ion-row>
</ion-grid>
